import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";
import { getFinalizePackageCallState } from "../../reducer/selectors";
import { ReviewErrorModal } from "./component";

const mapStateToProps = (state: IStoreState) => ({
  finalizePackageCallState: getFinalizePackageCallState(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ReviewErrorModalConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedReviewErrorModal = withRouter(
  connector(ReviewErrorModal)
);
